
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortName]/liquidity-pools",
      function () {
        return require("private-next-pages/[shortName]/liquidity-pools.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortName]/liquidity-pools"])
      });
    }
  